import { atomWithSessionStorage } from '@capsicum/common';

export const isWindowCloseAtom = atomWithSessionStorage<boolean>('isWindowClose', false);
